export function currencyFormatter(currency) {
    if (currency === 'UNKNOWN')
        currency = undefined;
    currency = currency || 'USD';
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
    });
    const format = (amount) => {
        if (amount === undefined || amount === null) {
            amount = 0;
        }
        const asDecimal = Number(amount.toFixed(2));
        const result = formatter.format(asDecimal);
        if (result === 'NaN') {
            return `Unknown`;
        }
        return result;
    };
    return format;
}
//# sourceMappingURL=currencyUtils.js.map